"use strict";

exports.__esModule = true;
exports.makePropEntry = void 0;
var _errors = require("../../common/errors");
var _config = require("../../entities/config");
var _record = require("../../entities/record");
var _schema = require("../../entities/schema");
var _value = require("../../entities/value");
var _makeValuePresentation = require("./make-value-presentation");
const makePropEntry = ({
  schema,
  schemas,
  currentRecord,
  propName,
  propConnection
}, dependencies) => {
  if (currentRecord) {
    const {
      value,
      fieldType
    } = getValueData({
      schema,
      currentRecord,
      schemas,
      propName,
      propConnection
    }, dependencies);
    if (shouldSetValue(dependencies.config, value)) {
      const valuePresentation = (0, _makeValuePresentation.makeValuePresentation)({
        propConnection,
        fieldType,
        value
      }, dependencies);
      return [propName, valuePresentation];
    }
  }
  return undefined;
};
exports.makePropEntry = makePropEntry;
const getValueData = ({
  schema,
  currentRecord,
  schemas,
  propConnection
}, dependencies) => propConnection.type === 'expression' ? evaluateExpression({
  propConnection,
  schema,
  currentRecord
}, dependencies) : getFieldData({
  propConnection,
  schema,
  schemas,
  currentRecord
}, dependencies);
const shouldSetValue = (config, value) => !(_config.Config.isLivePreviewEnabled(config) && _value.Value.isEmpty(value));
const evaluateExpression = ({
  propConnection: {
    expression
  },
  schema,
  currentRecord
}, {
  dataExpression,
  errorReporter
}) => {
  try {
    const {
      value
    } = dataExpression.evaluate({
      expression,
      variables: populateEmptyBooleanFields(currentRecord, schema)
    });
    return {
      value,
      fieldType: undefined
    };
  } catch (error) {
    errorReporter.report(_errors.CoreError.of('Failed to evaluate expression', {
      cause: error
    }));
    return {
      value: '',
      fieldType: undefined
    };
  }
};
const getFieldData = ({
  propConnection,
  currentRecord,
  schema,
  schemas
}, {
  errorReporter
}) => {
  const {
    fieldKey,
    path
  } = propConnection;
  const value = _record.Record.getValue(currentRecord, fieldKey, path);
  const fieldType = withErrorReporting(() => _schema.Schema.resolveFieldType(schema, propConnection, schemas), errorReporter);
  return {
    value,
    fieldType
  };
};
const withErrorReporting = (fn, errorReporter) => {
  try {
    return fn();
  } catch (error) {
    errorReporter.report(error);
  }
};
const populateEmptyBooleanFields = (record, schema) => {
  const updatedRecord = {};
  for (const [fieldKey, value] of Object.entries(record)) {
    updatedRecord[fieldKey] = _schema.Schema.isFieldOfType(schema, fieldKey, 'boolean') && _value.Value.isEmpty(value) ? false : value;
  }
  return updatedRecord;
};
//# sourceMappingURL=make-prop-entry.js.map